import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import DatePicker from "react-datepicker";
import DayJS from "dayjs";
import Box from "@/components/common/Box";
import ToggleSwitch from "@/components/common/ToggleSwitch";
import Button from "@/components/common/Button";
import Input from "@/components/common/Input";
import Select from "@/components/common/Select";
import Textarea from "@/components/common/TextArea";
import API from "@/api/index.js";
import RotaShift from "./RotaShift.jsx";

const RotaForm = ({ isEdit = false, currentValue, onCancel, onSubmit }) => {
  const [data, setData] = useState({
    title: "",
    description: "",
    role: "",
    startFrom: DayJS().startOf("hour").toDate(),
    shiftPattens: [],
    duty: false,
  });
  const [formErrors, setFormErrors] = useState({});

  const rolesFeed = useQuery({
    queryKey: ["users", "roles"],
    queryFn: () => API.settings.getRoles(),
    staleTime: 2000,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (isEdit) {
      setData(currentValue);
    }
  }, [isEdit, currentValue]);

  const handleSubmit = () => {
    // TODO validation

    // console.log("the data", data);

    onSubmit(data);
  };

  const onChange = (fieldName) => (e) => {
    setData({ ...data, [fieldName]: e.target.value });
  };

  return (
    <div>
      <div className={"p-2 pb-0"}>
        <div>
          <Input
            label={"Title"}
            field={"title"}
            value={data.title}
            error={formErrors.title}
            onChange={onChange("title")}
          />
        </div>
        <div>
          <Textarea
            label={"Description"}
            field={"description"}
            value={data.description}
            onChange={onChange("description")}
            error={formErrors.description}
          />
        </div>
        <div className="w-full flex items-center gap-4 ">
          <div className="w-1/2">
            <Select
              label={"Team Role"}
              options={rolesFeed.isSuccess && rolesFeed.data.map((item, key) => ({
                key: key._id,
                text: item.name,
                value: item.name,
              }))}
              error={formErrors.role}
              value={data.role || ""}
              onChange={(e) =>  setData({
                ...data,
                role: e.target.value,
              })}
            />
          </div>
          <div className="w-1/3">
            <ToggleSwitch
              label={"Duty Role"}
              label1={"No"}
              label2={"Yes"}
              field="duty"
              isChecked={data.duty}
              onChange={(e) => setData({ ...data, duty: e })}
            />
            <div className="text-muted-foreground text-xs italic">
              A duty role is one that has to be filled
            </div>
          </div>
        </div>
        <div className="w-full items-center">
          <label htmlFor={"date"} className={`block dark:text-zinc-400`}>
            First Shift Starts At
          </label>
          <DatePicker
            onChange={(date) => {
              setData({
                ...data,
                startFrom: DayJS(date).startOf("hour").toDate(),
              });
            }}
            selected={
              data.startFrom ? new Date(data.startFrom) : ""
            }
            showTimeSelect
            dateFormat="dd-MM-yy hh:mma"
            nextMonthButtonLabel=">"
            previousMonthButtonLabel="<"
            className="w-full rounded border border-pp bg-white p-1 dark:border-zinc-500 dark:bg-zinc-700"
            data-disable-touch-keyboard
          />
        </div>
        <div className={"mt-4"}>
          <Box title={"Shift Pattens"}>
            <RotaShift
              shiftPattens={data.shiftPattens}
              onChange={(a) => setData({ ...data, shiftPattens: a })}
            />
          </Box>
        </div>
      </div>
      <div className="flex justify-between p-2 mt-2 border-t border-gray-700">
        <Button onClick={() => onCancel()} size={"sm"} variant="destructive" text={"Cancel"} />
        <Button onClick={handleSubmit} size={"sm"} variant="success" text={isEdit ? "Update" : "Create"} />
      </div>
    </div>
  );
};
export default RotaForm;